<mat-list-item class="nav-menu__list-item" [class.nav-menu__list-item--module-active]="isActive"
    [ngClass]="linkData?.cssClass" [attr.data-cy]="linkData?.dataCy"
    attr.data-dd-action-name="{{linkData?.title}} Navigation Menu" (mouseenter)="onMouseOverModule(true)"
    (mouseleave)="onMouseOverModule(false)" (click)="handleModuleClick()">
    <button mat-icon-button>
        <mat-icon fontSet="material-symbols-outlined">{{ linkData?.icon }}</mat-icon>
        @if (!isCollapsed) {
        <span class="nav-menu__link__text">{{ linkData?.title }} </span>
        }
        @if (!isOpen && !isCollapsed && linkData?.showDealAlert === true) {
        <span class="custom-badge-accent badgePos2" matBadge="{{dealAlert}}" matBadgeOverlap="false"
            matBadgeColor="accent">
        </span>
        }
    </button>
    @if (!isCollapsed && linkData?.subItems.length !== 0) {
    <mat-icon class="nav-menu__list-item__icon-expand">{{ isOpen
        ? 'expand_less' : 'expand_more' }}</mat-icon>
    }
</mat-list-item>


@if (isOpen && !isCollapsed) {
<div>
    @for (subItem of linkData?.subItems; track subItem) {
    <div>
        @if (subItem.isVisible && subItem.url) {
        <a mat-list-item class="nav-menu__list-item nav-menu__list-item--sub-lvl-1"
            [class.nav-menu__list-item--item-active]="subItem.path === activeModuleItem" [routerLink]="subItem.url"
            [queryParams]="subItem.queryParams" [attr.data-cy]="subItem.dataCy"
            attr.data-dd-action-name="{{linkData.title}} - {{subItem.title}}">
            @if (!isCollapsed) {
            <span class="nav-menu__link__text">
                {{ subItem.title }}
            </span>
            }
            @if (subItem.showDealAlert === true) {
            <span class="custom-badge-accent" matBadge={{dealAlert}} matBadgeColor="accent">
            </span>
            }<span></span>
        </a>
        }
        <!-- don't use an anchor if the item doesn't have a URL -->
        @if (subItem.isVisible && !subItem.url) {
        <mat-list-item class="nav-menu__list-item nav-menu__list-item--sub-lvl-1"
            [class.nav-menu__list-item--item-active]="subItem.path === activeModuleItem">
            @if (!isCollapsed) {
            <span class="nav-menu__link__text">{{ subItem.title }}</span>
            }
        </mat-list-item>
        }
        @for (item of subItem?.subItems; track item) {
        <div>
            @if (item.isVisible) {
            <a mat-list-item class="nav-menu__list-item nav-menu__list-item--sub-lvl-2"
                [class.nav-menu__list-item--item-active]="item.path === activeModuleItem" [routerLink]="item.url"
                [queryParams]="item.queryParams" [attr.data-cy]="subItem.dataCy"
                attr.data-dd-action-name="{{linkData.title}} - {{subItem.title}} - {{item.title}}">
                @if (!isCollapsed) {
                <span class="nav-menu__link__text">{{ item.title }}</span>
                }
            </a>
            }
        </div>
        }
    </div>
    }
</div>
}

@if (showHoverMenu && isCollapsed) {
<div class="nav-menu__hovered-list" [class.nav-menu__hovered-list--module-active]="isActive"
    (mouseenter)="keepActive(true)" (mouseleave)="keepActive(false)">
    <h3 class="nav-menu__hovered-list__heading">
        {{ linkData?.title }}
    </h3>
    @for (subItem of linkData?.subItems; track subItem) {
    <div class="nav-menu__hovered-list__item">
        @if (subItem.isVisible) {
        <a mat-list-item (click)="keepActive(false)" class="nav-menu__list-item nav-menu__list-item--sub-lvl-1"
            [class.nav-menu__list-item--item-active]="subItem.path === activeModuleItem" [routerLink]="subItem.url"
            [queryParams]="subItem.queryParams" [attr.data-cy]="subItem.dataCy"
            attr.data-dd-action-name="{{linkData.title}} - {{subItem.title}}">
            <span class="nav-menu__link__text">{{ subItem.title }} </span>
            @if (subItem.showDealAlert === true) {
            <span class="custom-badge-accent" matBadge={{dealAlert}} matBadgeColor="accent">
            </span>
            }<span></span>
        </a>
        }
        @for (item of subItem?.subItems; track item) {
        <div>
            @if (item.isVisible) {
            <a mat-list-item class="nav-menu__list-item nav-menu__list-item--sub-lvl-2"
                [class.nav-menu__list-item--item-active]="item.path === activeModuleItem" [routerLink]="item.url"
                [queryParams]="item.queryParams"
                attr.data-dd-action-name="{{linkData.title}} - {{subItem.title}} - {{item.title}}">
                <span class=" nav-menu__link__text">{{ item.title }}</span>
            </a>
            }
        </div>
        }
    </div>
    }
</div>
}